import React from 'react';
import moment from 'moment';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { DurationStyle, formatDuration } from 'acscp/components/common/helpers/formatMoments';

interface DurationProps {
    duration: moment.Duration | null;
    style?: DurationStyle;
}

class DurationWithIntl extends React.Component<DurationProps & InjectedIntlProps, {}> {
    render(): JSX.Element {
        const style = this.props.style ? this.props.style : DurationStyle.Short;
        return (
            <span>{formatDuration(this.props.intl, this.props.duration, style)}</span>
        );
    }
}

export const Duration = injectIntl(DurationWithIntl);
